import { useState } from 'react';
import { Link } from 'react-router-dom';
import exit from '../../assets/images/icons/exit.svg';
import home from '../../assets/images/icons/home.svg';
import { useAppContext } from '../../contexts/auth';
import useGetGeneralAppData from '../../hooks/useGetGeneralAppData';
import Loader from '../Loader';
import AdminNavbar from './components/AdminNavbar';
import ClientNavbar from './components/ClientNavbar';
import DownloadGeneralReportsModal from './components/DownloadGeneralReportsModal';
import { ActiveItem, Container, MenuItem } from './styles';

interface NavbarInterface {
  active: string;
}

export default function Navbar({ active }: NavbarInterface) {
  const [generalReportsModalShow, setGeneralReportsModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { signOut } = useAppContext();
  const { userProfile } = useGetGeneralAppData();
  const isClient = userProfile >= 10;

  return (
    <>
      <Loader isLoading={isLoading} />

      <Container>
        {active === 'Home'
          ? (
            <ActiveItem>
              <Link to="/">
                <MenuItem>
                  <img src={home} alt="home" />
                  Home
                </MenuItem>
              </Link>
            </ActiveItem>
          )
          : (
            <Link to="/">
              <MenuItem>
                <img src={home} alt="home" />
                Home
              </MenuItem>
            </Link>
          )}

        {(isClient)
          ? (<ClientNavbar active={active} setGeneralReportsModalShow={setGeneralReportsModalShow} />)
          : (<AdminNavbar active={active} setGeneralReportsModalShow={setGeneralReportsModalShow} />)}

        <MenuItem onClick={() => signOut({ redirect: true })}>
          <img src={exit} alt="bus" />
          Sair
        </MenuItem>

      </Container>

      <DownloadGeneralReportsModal
        downloadModalShow={generalReportsModalShow}
        setDownloadModalShow={setGeneralReportsModalShow}
        setIsLoading={setIsLoading}
      />
    </>
  );
}
